import { useLocation } from 'react-router-dom';
import { useEquipmentContext } from '../contexts/EquipmentContext';
import {
    EquipmentCategoryFormContent,
    EquipmentNewUnitContent,
    EquipmentUnitDetailContent,
} from './pages-equipment';
import '../css/SingleUnitContent.css';

export const SingleUnitContent = () => {
    const location = useLocation();
    const { loading } = useEquipmentContext();

    const isCategoryPage = location.pathname.startsWith('/equipment/category/');
    const isNewUnitPage = location.pathname === '/equipment/new';

    if (loading && !isCategoryPage && !isNewUnitPage) {
        return <div className="loading">Loading...</div>;
    }

    if (isCategoryPage) {
        return <EquipmentCategoryFormContent />;
    }

    if (isNewUnitPage) {
        return <EquipmentNewUnitContent />;
    }

    return <EquipmentUnitDetailContent />;
};
